import { defineComponent as _defineComponent } from 'vue'
import { withDefaults } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'InputGroup',
  props: {
    label: null,
    inline: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props as { label?: string, inline: boolean };



return { __sfc: true,props }
}

})